import { Box, Grid, Skeleton, Stack, useMediaQuery } from "@mui/material";
import { greyShade47, greyShade58 } from "configs/styles/muiThemes";
import React from "react";
import { scrollBox } from "utils/styleUtility";

function ProductByCategoryShimmer() {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return matches ? (
    <Stack>
      <Box
        height="33px"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Skeleton
          variant="rectangle"
          width="20%"
          height={23}
          sx={{ borderRadius: "4px" }}
        />
        <Box display="flex" alignItems={"center"} gap={2}>
          <Skeleton
            variant="rectangle"
            width="120px"
            height={23}
            sx={{ borderRadius: "4px" }}
          />
          <Skeleton
            variant="rectangle"
            width="30px"
            height={30}
            sx={{ borderRadius: "4px" }}
          />
          <Skeleton
            variant="rectangle"
            width="30px"
            height={30}
            sx={{ borderRadius: "4px" }}
          />
        </Box>
      </Box>
      <Grid container columnSpacing="9.6px" rowSpacing={{ md: 2.5, xs: 0 }}>
        <Grid item xs={12} sm={3} md={2.4}>
          <Skeleton
            variant="rectangle"
            width="100%"
            height={242}
            sx={{ borderRadius: "10px" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.4}>
          <Skeleton
            variant="rectangle"
            width="100%"
            height={242}
            sx={{ borderRadius: "10px" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.4}>
          <Skeleton
            variant="rectangle"
            width="100%"
            height={242}
            sx={{ borderRadius: "10px" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.4}>
          <Skeleton
            variant="rectangle"
            width="100%"
            height={242}
            sx={{ borderRadius: "10px" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.4}>
          <Skeleton
            variant="rectangle"
            width="100%"
            height={242}
            sx={{ borderRadius: "10px" }}
          />
        </Grid>
      </Grid>
    </Stack>
  ) : (
    <Stack p="0px 15px">
      <Box display="flex" justifyContent="space-between" minHeight="35px">
        <Box display="flex">
          <Skeleton variant="rectangular" width="150px" height={25} />
          <Box
            component="span"
            color={greyShade58}
            fontSize={{ xs: "13px", md: "14px" }}
            fontWeight={400}
            mx={1}
            textAlign="center"
          >
            ·
          </Box>
          <Skeleton variant="rectangular" width="40px" height={25} />
        </Box>
        {/* <Skeleton variant="rectangular" width="25px" height={25} /> */}
      </Box>
      <Box display="flex" alignItems="center" gap="15px" sx={scrollBox}>
        <ProductCardOne />
        <ProductCardOne />
        <ProductCardOne />
      </Box>
    </Stack>
  );
}

export default ProductByCategoryShimmer;

const ProductCardOne = () => (
  <Box>
    <Skeleton
      variant="rounded"
      width="125px"
      height="125px"
      sx={{ borderRadius: "8px", m: "0 !important" }}
    />

    <Skeleton
      variant="rounded"
      width="120px"
      height="10px"
      sx={{ m: "10px 0 2px 0 !important" }}
    />
    <Skeleton
      variant="rounded"
      width="90px"
      height="10px"
      sx={{ m: "5px 0 2px 0 !important" }}
    />
    <Skeleton
      variant="rounded"
      width="50px"
      height="12px"
      sx={{ m: "8px 0 2px 0 !important" }}
    />
    <Skeleton
      variant="rounded"
      width="50px"
      height="12px"
      sx={{ m: "8px 0 2px 0 !important" }}
    />
  </Box>
);
